import type { BillboardDetailData } from '@/features/billboards/api/billboardApi';
import { ScreenMap } from '@/features/billboards/components/detail/ScreenMap';
import { SectionTitle } from '@/features/billboards/components/detail/SectionTitle';

type AddressSectionProps = {
  billboard: BillboardDetailData;
  fullAddress: string;
  lat?: number;
  lng?: number;
};

export function AddressSection({
  billboard,
  fullAddress,
  lat,
  lng,
}: AddressSectionProps) {
  const addressChips = [
    { label: 'BUILDING', value: billboard.address?.building || '—' },
    {
      label: 'AREA',
      value: billboard.address?.area || billboard.address?.locality || '—',
    },
    {
      label: 'SECONDARY',
      value: billboard.address?.secondaryAddress || '—',
    },
    {
      label: 'POSTAL CODE',
      value: billboard.address?.pincode || billboard.pincode || '—',
    },
    { label: 'CITY', value: billboard.address?.city || '—' },
    { label: 'DISTRICT', value: billboard.address?.district || '—' },
    { label: 'STATE', value: billboard.address?.state || '—' },
    {
      label: 'COUNTRY',
      value: billboard.address?.country || 'India',
    },
  ];

  /* Modified by: Ishan | Soft-contrast address section card with location chips and map */
  return (
    <section className="mt-5 rounded-[24px] border border-[#EEEBF8] bg-white p-[22px] shadow-[0_10px_30px_rgba(60,40,120,0.05)]">
      <SectionTitle
        title="Address"
        subtitle="Exact location of this screen"
      />
      <div className="mb-4 text-left text-[14px] font-bold text-[#3A3660]">
        {fullAddress}
      </div>
      <div className="my-4 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {addressChips.map((chip) => (
          <div
            key={chip.label}
            className="rounded-[16px] border border-[#EEEBF8] bg-white p-3.5 text-left"
          >
            <div className="text-[11px] font-bold tracking-[0.5px] text-[#6A6688] uppercase">
              {chip.label}
            </div>
            <div className="mt-1 text-[15px] font-extrabold text-[#3A3660] break-words">
              {chip.value}
            </div>
          </div>
        ))}
      </div>
      <div className="mt-5">
        <ScreenMap lat={lat} lng={lng} title={billboard.screenName} />
      </div>
    </section>
  );
}
